import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { auth } from '@/firebaseConfig'

import {
  hasAccessRightForCollection,
  AccessRightWrite
} from '@/plugins/feature'


Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/components/AppContainer.vue'),
    meta: { requiresAuth: true, requiresCompany: true },
    redirect: { name: 'jobs' },
    children: [
      {
        path: 'clients',
        name: 'clients',
        component: () => import('@/views/Clients.vue')
      },
      {
        path: 'projects',
        name: 'projects',
        component: () => import('@/views/projects/Projects.vue')
      },
      {
        path: 'projects/:id',
        name: 'project-details',
        redirect: { name: 'project-about' },
        component: () => import('@/views/projects/ProjectDetails.vue'),
        props: true,
        children: [
          {
            path: 'about',
            name: 'project-about',
            component: () => import('@/views/projects/About.vue'),
            props: true
          },
          {
            path: 'tasks',
            name: 'project-jobs',
            component: () => import('@/views/projects/Jobs.vue'),
            props: true
          },
        ],
      },
      {
        path: 'tasks',
        name: 'jobs',
        component: () => import('@/views/jobs/Jobs.vue'),
        redirect: { name: 'task-list' },
        children: [
          {
            path: 'list',
            name: 'task-list',
            component: () => import('@/views/jobs/List.vue')
          },
          {
            path: 'calendar',
            name: 'task-calendar',
            component: () => import('@/views/jobs/Calendar.vue')
          }
        ]
      },
      {
        path: 'tasks/:id',
        name: 'job-details',
        component: () => import('@/views/jobs/JobDetails.vue'),
        props: true
      },
      {
        path: 'warehouse',
        name: 'warehouse',
        redirect: { name: 'warehouse-stock' },
        component: () => import('@/views/warehouse/Warehouse.vue'),
        children: [
          {
            path: 'stock',
            name: 'warehouse-stock',
            component: () => import('@/views/warehouse/Inventory.vue')
          },
          {
            path: 'locations',
            name: 'warehouse-locations',
            component: () => import('@/views/warehouse/LocationSettings.vue'),
          },
          {
            path: 'categories',
            name: 'stock-categories',
            component: () =>
              import('@/views/warehouse/InventoryCategorySettings.vue')
          }
        ]
      },
      {
        path: 'warehouse/locations/:id',
        name: 'location-details',
        component: () => import('@/views/warehouse/LocationDetails.vue'),
        props: true
      },
      {
        path: 'people',
        name: 'people',
        redirect: { name: 'workforce' },
        component: () => import('@/views/people/People.vue'),
        children: [
          {
            path: 'workforce',
            name: 'workforce',
            component: () => import('@/views/people/Workforce.vue')
          },
          {
            path: 'contractors',
            name: 'contractors',
            component: () => import('@/views/people/Contractors.vue')
          }
        ]
      },
      {
        path: 'profile/:id',
        name: 'profile',
        component: () => import('@/views/people/profile/Profile.vue'),
        props: true,
        meta: { requiresAuth: true, requiresCompany: true, restricted: ['workforce'] },
        redirect: { name: 'profile-personal' },
        children: [
          {
            path: 'personal',
            name: 'profile-personal',
            component: () => import('@/views/people/profile/components/Personal.vue'),
            props: true
          },
          {
            path: 'employment',
            name: 'profile-employment',
            component: () => import('@/views/people/profile/components/Employment.vue'),
            props: true
          },
          {
            path: 'children',
            name: 'profile-children',
            component: () => import('@/views/people/profile/components/Children.vue'),
            props: true
          },
          {
            path: 'medical',
            name: 'profile-medical',
            component: () => import('@/views/people/profile/components/Medical.vue'),
            props: true
          },
          {
            path: 'emergency-contact',
            name: 'profile-emergency-contact',
            component: () => import('@/views/people/profile/components/EmergencyContact.vue'),
            props: true
          }
        ]
      },
      {
        path: 'people/contractors/:id',
        name: 'contractor-details',
        component: () => import('@/views/people/ContractorDetails.vue'),
        props: true
      },
      {
        path: 'clients/:id',
        name: 'client-details',
        component: () => import('@/views/ClientDetails.vue'),
        props: true
      },
      {
        path: 'settings',
        name: 'settings',
        redirect: { name: 'company-settings' },
        component: () => import('@/views/settings/Settings.vue'),
        children: [
          {
            path: 'company',
            name: 'company-settings',
            component: () =>
              import('@/views/settings/components/CompanySettings.vue')
          }
        ]
      },
      {
        path: 'forbidden',
        name: 'forbidden',
        component: () => import ('@/views/Forbidden.vue')
      }
    ]
  },
  {
    path: '/auth',
    component: () => import('@/components/AuthContainer.vue'),
    meta: { requiresAuth: false, requiresCompany: false },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/auth/Login.vue'),
        meta: { requiresAuth: false, requiresCompany: false }
      },
      {
        path: 'launchpad',
        name: 'launchpad',
        component: () => import('@/views/Launchpad.vue'),
        meta: { requiresAuth: true, requiresCompany: false }
      },
      {
        path: 'check-email',
        name: 'signin-check-email',
        component: () => import('@/views/auth/CheckEmailSignIn.vue'),
        meta: { requiresAuth: false, requiresCompany: false },
      },
      {
        path: 'email',
        name: 'signin-email',
        component: () => import('@/views/auth/Email.vue'),
        meta: { requiresAuth: false, requiresCompany: false }
      },
      {
        path: 'register',
        name: 'register',
        component: () => import('@/views/auth/register/Register.vue'),
        meta: { requiresAuth: false, requiresCompany: false }
      },
      {
        path: 'emailaction',
        name: 'emailaction',
        component: () => import('@/views/auth/actions/EmailActions.vue'),
        meta: { requiresAuth: false, requiresCompany: false },
      },
      {
        path: 'password-reset',
        name: 'password-reset',
        component: () => import('@/views/auth/ForgotPassword.vue'),
      },
      {
        path: 'new-password',
        name: 'new-password',
        component: () => import('@/views/auth/NewPassword.vue'),
        props: true
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const requiresCompany = to.matched.some(
    (record) => record.meta.requiresCompany
  )
  const restrictedRoute = to.matched.find((record) => record.meta.restricted)

  store.dispatch('clearSearch')
  
  if (to.name === 'emailaction') {
    next()
    return
  }

  const user = auth.currentUser

  if (requiresAuth && !user) {
    next({ name: 'login' })
  } else if (user && !user.emailVerified && to.name !== 'register') {
    next({name: 'register'})
  } else if (requiresCompany && !store.getters.companyId) {
    next({ name: 'launchpad' })
  } else if (to.name == 'login' && user) {
    next({ name: 'inventory' })
  } else if (restrictedRoute) {
    for (const collectionName of restrictedRoute.meta.restricted) {
      
      if (!hasAccessRightForCollection(collectionName, AccessRightWrite) && to.params?.id !== user.uid) {
        next({ name: 'forbidden', replace: true })
        break
      }
    }
    next()
  } else {
    next()
  }
})

export default router
